import { Component, OnInit } from '@angular/core';
import { firstValueFrom, switchMap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { ContactModal } from 'src/app/shared/modals/contact/contact-modal.component';
import { CancelModal } from 'src/app/shared/modals/cancel/cancel-modal.component';
import { BankAccountDto } from 'src/app/domain/models/dto/bank-account.dto';
import { BankDto } from 'src/app/domain/models/dto/bank.dto';
import { PurposeStatementDto } from 'src/app/domain/models/dto/purpose-statement.dto';
import { SocioEnvironmentalTermsDto } from 'src/app/domain/models/dto/socio-environmental-terms.dto';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { PurposeStatementService } from 'src/app/shared/services/purpose-statement.service';
import { RegisterService } from 'src/app/shared/services/register.service';
import { SocioEnvironmentalService } from 'src/app/shared/services/socio-environmental.service';
import { AuthenticationService } from 'src/app/shared/services';
import { RegisterStepType } from 'src/app/domain/enums/register-step-types.enum';
declare const $: any;

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: [],
})
export class MoreInfoComponent implements OnInit {
  private readonly notifier: NotifierService;
  tenant: string = '';
  public loading: boolean;
  bank = '';
  banks: BankDto[] = [];
  controlBank: string = ".js-control-bank";
 
  purposeStatements = new PurposeStatementDto();
  bankAccount = new BankAccountDto();
  socioEnvironmental = new SocioEnvironmentalTermsDto();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private readonly registerService: RegisterService,
    private readonly modalService: BoobleModalService,
    private readonly companyService: CorporateAccountService,
    private readonly authService: AuthenticationService,
    private readonly bankAccountService: BankAccountService,
    private readonly socioEnvironmentalService: SocioEnvironmentalService,
    private readonly purposeStatementService: PurposeStatementService,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    // firstValueFrom(this.bankAccountService.getBanks()).then((value) => this.banks = value.data);
    firstValueFrom(this.companyService.get()).then(value => {
      // if (value.data.bankAccountId) {
      //   firstValueFrom(this.bankAccountService.get(value.data.bankAccountId)).then((value) => {
      //     let element = (document.getElementById('select2-bank-container') as HTMLSpanElement);
      //     this.bankAccount = value.data;
      //     element.innerHTML = value.data.bank;
      //   });
      // }
      if (value.data.purposeStatement.id) {
        firstValueFrom(this.purposeStatementService.get(value.data.purposeStatement.id)).then((value) => { this.purposeStatements = value.data; });
      }
      if (value.data.socioenvironmentalTerm.id) {
        firstValueFrom(this.socioEnvironmentalService.get(value.data.socioenvironmentalTerm.id)).then((value) => this.socioEnvironmental = value.data);
      }
    });
    this.route.paramMap.subscribe(params => {
      const result = params.get('tenant');

      if (result)
        this.tenant = params.get('tenant');
    });
    this.setControls();

  }

  changeSocioEnvResponsability(value) {
    this.socioEnvironmental.hasResponsibility = value;
  }

  changePurposeOption(event, option) {
    this.purposeStatements[option] = event.target.checked;
  }

  // changeBank(bank) {
  //   this.bankAccount.bank = bank;
  // }

  setControls() {
    $(this.controlBank).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });

    let t = this;
    $(this.controlBank).on('change', function () {
      t.changeDocumentForm($(this).val());
    });

  }

  changeDocumentForm(text: string) {
    this.bankAccount.bank = text;
  }

  openContactModal() {
    this.modalService.present(ContactModal);
  }

  register() {
    this.loading = true;

    // if (this.bankAccount.bank) {
    //   this.bankAccount.code = this.bankAccount.bank.split(' - ')[0];
    //   this.bankAccount.name = this.bankAccount.bank.split(' - ')[1];
    // }

    this.companyService.updateSocioEnvironmentalTerms(+this.authService.getCompanyId(), this.socioEnvironmental)
      .pipe(
        switchMap((socio) => this.companyService.updatePurposeStatement(+this.authService.getCompanyId(), this.purposeStatements)))
      .subscribe(() => {
        this.goNext();
      }, (err) => {
        this.loading = false;
      });

  }

  handleMarkAllPurpose(event) {
    var target = event.target;
    if (target.checked) {
      this.purposeStatements.availability = true;
      this.purposeStatements.declarationOfResidents = true;
      this.purposeStatements.export = true;
      this.purposeStatements.import = true;
      this.purposeStatements.investments = true;
      this.purposeStatements.paymentsAbroad = true;
      this.purposeStatements.receiptsAbroad = true;
      this.purposeStatements.tourism = true;
    } else {
      this.purposeStatements.availability = false;
      this.purposeStatements.declarationOfResidents = false;
      this.purposeStatements.export = false;
      this.purposeStatements.import = false;
      this.purposeStatements.investments = false;
      this.purposeStatements.paymentsAbroad = false;
      this.purposeStatements.receiptsAbroad = false;
      this.purposeStatements.tourism = false;
    }
  }

  handleSocioEnvironemntalYesCheck(event) {
    var target = event.target;
    if (target.checked) {
      this.socioEnvironmental.licenceStatusType = 'HaveALicence';
    }
  }

  handleSocioEnvironemntalNoCheck(event) {
    var target = event.target;
    if (target.checked) {
      this.socioEnvironmental.licenceStatusType = 'NotLicence';
    }
  }

  handleSocioEnvironemntalNotApplicableCheck(event) {
    var target = event.target;
    if (target.checked) {
      this.socioEnvironmental.licenceStatusType = 'NotApplicable';
    }
  }

  goNext() {
    this.loading = true;
    this.registerService.putRegisterStep(RegisterStepType.MoreInfo).subscribe({
      next: (stepResult) => {
        this.loading = false;
        this.router.navigate([`${this.tenant}/onboardings/second-limit`]);
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  goPrevious() {
    this.router.navigate([`${this.tenant}/onboardings/responsible-documents`]);
  }

  openCancelModal() {
    this.modalService.present(CancelModal);
  }

}
